"use client";
import React, {
    Suspense,
    useEffect,
    useLayoutEffect,
    useState,
    useRef,
} from "react";
import { useSession, signOut } from "next-auth/react";
import { usePathname, useRouter } from "next/navigation";
import Transition from "./Transition";
import { setCookie } from "cookies-next";
import { useResetAllStores } from "../lib/Hooks/useResetAllStores";
import PromoBanner from "../components/Molecules/PromoBanner";
import NewFooterSection from "../components/Molecules/NewFooterSection";
import Loading from "./loading";
import NewHeaderSection from "../components/Molecules/NewHeaderSection";
import useUserStore from "../lib/Store/useUserStore";
import { validateUserToken, setUserCookies } from "../lib/User/action";
import useFirebaseLogging from "../utils/firebaseUtils";
import { deleteWardrobeCookies } from "../components/utils/utils";
import {
    SAUDI_ISO,
    DUBAI_ISO,
    PROMO_BANNER,
    FOOTER,
    AUTHENTICATED,
    UNAUTHENTICATED,
    // HOTJAR_JS_PATH,
    PROMO_RESTRICTED_ROUTES,
    FOOTER_RESTRICTED_ROUTES,
    USER_NOT_FOUND,
} from "../public/Constants/EnumConstants";
import PageTopBanner from "../components/Molecules/PageTopBanner";

const App = ({ children, userCountry }) => {
    const { userData, getCustomerData } = useUserStore();
    const { status } = useSession();
    const pathName = usePathname();
    const resetAllStores = useResetAllStores();
    const router = useRouter();
    const previousRoute = useRef(router.asPath);

    useEffect(() => {
        const testUserToken = async () => {
            if (!userData) {
                const valid = await validateUserToken();
                if (valid) {
                    await getCustomerData();
                } else resetAllStores({ logout: true });
            } else {
                await getCustomerData();
            }
        };
        if (status === AUTHENTICATED) {
            testUserToken();
        } else if (status === UNAUTHENTICATED) {
            resetAllStores();
        }
    }, [status]);

    // useEffect(() => {
    //     const logEvent = async () => {
    //         await logEventToFirebase("page_view", {
    //             route: pathName,
    //         });
    //     };

    //     logEvent();
    // }, [pathName]);

    //Page views are already tracked by datadog

    useEffect(() => {
        deleteWardrobeCookies(pathName);
    }, [pathName]);

    const isVisible = (section) => {
        if (section === PROMO_BANNER) {
            return !PROMO_RESTRICTED_ROUTES?.find((route) =>
                pathName?.includes(route)
            );
        } else if (section === FOOTER) {
            return !FOOTER_RESTRICTED_ROUTES?.find((route) =>
                pathName?.includes(route)
            );
        } else if (section === "HEADER") {
            return !["eoywrap"]?.find((route) => pathName?.includes(route));
        }
        return true;
    };

    return (
        <Suspense>
            <PageTopBanner countryFlag={userCountry?.flag} />
            {isVisible("HEADER") && (
                <NewHeaderSection homeUrl={"/"} userCountry={userCountry} />
            )}
            {isVisible(PROMO_BANNER) && (
                <PromoBanner userCountry={userCountry} />
            )}
            <Transition>
                <Suspense>{children}</Suspense>
            </Transition>

            {isVisible(FOOTER) && <NewFooterSection homeUrl={"/"} />}
        </Suspense>
    );
};

export default App;
